import { render } from "./GroupWrapper.vue?vue&type=template&id=0d9aa4bc&ts=true"
import script from "./GroupWrapper.vue?vue&type=script&lang=ts"
export * from "./GroupWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__